 //MobileNavigation.js

 import NavLinks from "./Components/Navigation/NavLinks";
 import './Components/Navigation/NavBar.css'
 import { TiThMenuOutline } from "react-icons/ti";
 import { useState } from "react";

 


 const MobileNavigation = () =>{
    const [click, setclick] = useState(false);

    
    const Hamburger = <TiThMenuOutline className="HamburgerMenu"
    size="30px" 
    color="black"
    onClick={() => setclick(!click)}
    />
     return(
        
        <nav className="MobileNavigation">
              {Hamburger}
              {click && <NavLinks />}
        </nav>
        
     )
 }

 export default MobileNavigation;

 // Note that NavBar.css and NavLinks.js are imported here
